
import { useConsumption } from '../../../hooks'

export default function CounterDevicenameSelectedPresenter() {
   const {filter} =  useConsumption()
  return (
    <>{filter.device_name || 'Aucun compteur'}</>
  )
}
